import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import About from './pages/About';
import Charge from './pages/Charge';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuthStore } from './store/authStore';
import GoogleAnalytics from './components/GoogleAnalytics';

function App() {
  const initialize = useAuthStore((state) => state.initialize);
  const checkAndRefreshSession = useAuthStore((state) => state.checkAndRefreshSession);

  useEffect(() => {
    initialize();
    
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        await checkAndRefreshSession();
      }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);
    return () => window.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [initialize, checkAndRefreshSession]);

  return (
    <Router>
      <GoogleAnalytics />
      <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute />}>
              <Route index element={<Navigate to="leads" replace />} />
              <Route path=":tab" element={<Dashboard />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/charge" element={<Charge />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;